

import { Navigate, useLocation } from "react-router-dom";

export default function AdminProtected({ children }) {
  const location = useLocation();

  const isAdminAuthenticated = !!sessionStorage.getItem("admin");

  if (!isAdminAuthenticated) {
    if (location.pathname.startsWith("/volunteer")) {
      return <Navigate to="/volunteer/login" replace />;
    }

    return <Navigate to="/login" replace />;
  }

  return children;
}
